<template>
    <div class="call-container">
        <div class="params-setting-wrapper">
            <div class="params-item">
                <span class="params-item-title">参数调节：</span>
            </div>
            <div class="params-item">
                <span class="params-item-title">Max Length</span>
                <el-slider show-input v-model="params.maxTokens" :min="1" :max="4096" :step="1"></el-slider>
            </div>
            <div class="params-item">
                <span class="params-item-title">Top P</span>
                <el-slider show-input v-model="params.topP" :min="0" :max="1" :step="0.01"></el-slider>
            </div>
            <div class="params-item">
                <span class="params-item-title">Temperature</span>
                <el-slider show-input v-model="params.temperature" :min="0" :max="1" :step="0.01"></el-slider>
            </div>
            <div class="params-item">
                <span class="params-item-title">Top K</span>
                <el-slider show-input v-model="params.topK" :min="0" :max="100" :step="1"></el-slider>
            </div>
            <div class="params-item">
                <span class="params-item-title">Repetition Penalty</span>
                <el-slider show-input v-model="params.repetitionPenalty" :min="0.1" :max="10" :step="0.1"></el-slider>
            </div>
        </div>
        <div class="right-content">
            <div class="trans-title">
                <img class="trans-title-img" src="../../../theme/images/trans_gpt-title.png" alt="">
            </div>
            <template> <!-- 常规对话 -->
                <div class="msg-box-flex-wrapper">
                    <MsgBoxScroll>
                        <template v-for="(msg, index) in currentChat.messages">
                            <MsgUserAsk v-if="msg.role === 'user'" :key="index" :ref="`msg${index}`" :data="msg"
                                        @askAgain="prompt = $event"/>
                            <MsgChatRespond v-else-if="msg.role === 'assistant'" :key="index" :ref="`msg${index}`"
                                            :showOperate="false"
                                            :showStop="SseChecked"
                                            :askData="currentChat.messages[index-1]"
                                            :data="msg" :index="index">
                                <div class="ai-img" slot="assistantImg"></div>
                            </MsgChatRespond>
                            <div v-else :key="index">{{ msg.content }}</div>
                        </template>
                    </MsgBoxScroll>
                </div>
                <div class="operate-wrapper">
                    <el-checkbox class="operate-item" v-model="SseChecked">流式输出</el-checkbox>
                    <el-checkbox class="operate-item" v-model="ContextChecked">带上下文对话</el-checkbox>
                    <!--                    <div class="operate-item params-setting" @click="paramsSettingDrawer = true">-->
                    <!--                        <i class="el-icon-s-tools"></i>-->
                    <!--                        <span>参数调节</span>-->
                    <!--                    </div>-->
                </div>
                <div class="input-box-flex-wrapper">
                    <div class="input-placeholder"></div>
                    <gpt-chatbox :class="[(ui.typing ? 'typing' : '')]" v-if="modelList.length"
                                 :simpleChatBox="true" :showMic="false"
                                 v-loading="ui.isSocketReconnecting" element-loading-text="会话连接中..."
                                 :modelList="modelList" :input.sync="prompt" :model.sync="model" :typing="ui.typing"
                                 :sessionId="currentChat && currentChat.sessionId"
                                 @commonAsk="commonAsk">
                    </gpt-chatbox>
                    <div class="input-placeholder"></div>
                </div>
            </template>
        </div>
        <div class="bottom-tips">内容由AI生成，仅供参考，请遵守《<span class="server-tips" @click="serverTipsShow = true">TransGPT免责声明</span>》</div>
        <el-dialog
            title="TransGPT免责声明"
            :visible.sync="serverTipsShow"
            :modal-append-to-body="false"
            width="50%"
            custom-class="server-tips-dialog"
            center>
<!--            <div class="tips-top">-->
<!--                <div></div>-->
<!--                <div class="time-wrapper">-->
<!--                    <span>生效日期：2023年12月18日</span>-->
<!--                    <span>更新日期：2023年12月15日</span>-->
<!--                </div>-->
<!--            </div>-->
            <div class="tips-content" v-html="tipsContent"></div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="serverTipsShow = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import historyAPI from '@/api/history.api.js';
import SseMixin from '@/app/mixins/SseMixin.js';
import httpChatAPI from '@/api/httpChat.api.js';

import MsgBoxScroll from '@/app/components/ui/MsgBoxScroll.vue';
import MsgUserAsk from '@/app/components/chatMsg/MsgUserAsk.vue';
import MsgChatRespond from '@/app/components/chatMsg/MsgChatRespond.vue';
import { TIPS_CONTENT } from './TIPS_CONTENT';

// 测试版对话页面--一次性对话
export default {
    name: 'transGpt',
    components: {
        MsgBoxScroll,
        MsgUserAsk,
        MsgChatRespond
    },
    mixins: [SseMixin],
    data () {
        return {
            tipsContent: '',
            prompt: '', // 当前输入内容
            model: null, // 当前使用哪个模型
            ui: {
                typing: false // 是否在输入中
            },
            currentChat: {
                title: '',
                sessionId: '',
                messages: [],
                updateTime: 0
            },
            mdTempStr: '', // 多模态输出临时字符串
            currentSessionId: '',
            modelSettings: {
                maxLength: 1024,
                contextLimit: 3,
                temperature: 0.6
            },
            SseChecked: true,
            ContextChecked: true,
            paramsSettingDrawer: true,
            params: {
                maxTokens: 2048,
                topP: 0.7,
                temperature: 0.95,
                topK: 40,
                repetitionPenalty: 1
            },
            serverTipsShow: false
        };
    },
    provide () {
        return {
            currentSessionId: () => this.currentSessionId,
            stopGenerating: this.stopGenerating
        };
    },
    computed: {
        useLLM () {
            return this.$store.state.appSettings.useLLM;
        },
        modelList () {
            return this.$store.state.appSettings.modelList;
        }
    },
    async mounted () {
        // 同一台机子如果先访问了正常的知行助手页面，登录了，（公服会将cookie强制写入前浏览器，并且前端清除不了,httponly）
        // if (this.$store.state.account.token) {
        //     await accountApi.ssoLogout();
        // }
        await this.$store.dispatch('appSettings/initModelList');
        await this.newChat(); // 新建会话
        // 转换\n为<br/>
        this.tipsContent = TIPS_CONTENT.replace(/\n/g, '<br/>');
    },
    methods: {
        /**
         * 创建新聊天
         */
        async newChat () {
            if (this.ui.typing) return;
            if (this.ui.isLoadingChat) return;
            this.ui.isLoadingChat = true;
            this.model = 'commonMode';
            let result = await historyAPI.getNewSessionId();
            // 创建时先不保存数据
            this.currentSessionId = result.data;
            this.currentChat = {
                collected: 0,
                title: '',
                sessionId: result.data,
                messages: [],
                createdTimeStamp: Date.now()
            };

            this.ui.isLoadingChat = false;
        },

        /**
         * 停止生成
         */
        async stopGenerating () {
            if (!this.ui.typing) return;
            // 停止sse接口返回
            this.sseController && this.sseController.abort();

            let last = this.currentChat.messages[this.currentChat.messages.length - 1];
            // 打字完成
            this.ui.typing = false;
            if (last && last.role === 'assistant') this.$set(last, 'finished', true);
        },
        /**
         * 改变模型参数
         */
        changeModelSetting () {
            let model = this.$store.state.appSettings.modelList.find(item => item.value === this.model);
            if (model && model.modelSettings) {
                this.modelSettings = model.modelSettings;
            } else {
                this.modelSettings = {
                    maxLength: 1024,
                    contextLimit: 3,
                    temperature: 0
                };
            }
        },
        /**
         * 新增提问
         * input 用户输入的内容（在对话中显示）
         * prompt 发给机器人学习的内容（不在对话中显示）
         * questionTime 提问时间
         */
        async addAsk (input, prompt, questionTime) {
            let askMsg = { role: 'user', content: input, questionTime };
            if (prompt) askMsg['notShowContent'] = prompt;
            this.currentChat.messages.push(askMsg);
        },

        /**
         * 普通对话提问
         */
        commonAsk (data) {
            if (this.ui.typing) return;
            let prompt = data.input;
            let useLLM = this.useLLM;
            this.prompt = '';
            this.addAsk(prompt);
            let msg = {
                'message': prompt,
                'model': useLLM,
                'stop': ['\r\n\r\nHuman', '\r\nHuman', '\n\nHuman', '\nHuman'], // 流式停止标识
                contextLimit: this.ContextChecked ? 5 : 0,
                ...this.params
            };
            // 开始等待打字
            this.ui.typing = true;
            this.currentChat.messages.push({ role: 'assistant', content: '', feedback: null, finished: false, thinking: true });
            if (this.SseChecked) {
                this.sendSseStream(msg);
            } else {
                this.sendHttpChat(msg);
            }
        },
        // 非流式，http请求对话
        async sendHttpChat (msg) {
            let res = await httpChatAPI.sendHttpChat(msg, this.currentSessionId);
            let index = this.currentChat.messages.length - 1;
            let last = this.currentChat.messages[index]; // 最后一条消息（回答，用于打字）
            if (res.status !== 200) {
                last.content = res.statusText;
            } else if (res.statusCode !== 200) {
                // 其他错误
                last.content = res.opDesc;
            } else {
                last.content = res.data.content;
            }
            last.thinking = false;
            this.$set(last, 'finished', true);
            this.ui.typing = false;
        }
    }
};
</script>
<style scoped lang="scss">

.call-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;

    .ai-img {
        content: url('../../../theme/images/trans_gpt.png');
    }
    .trans-title {
        width: 100%;
        display: flex;
        align-items: center;
        padding-left: 60px;
        max-width: 1000px;
        padding-top: 32px;
    }
    .trans-title-img {
        width: 140px;
    }
    .right-content {
        position: relative;
        width: 100%;
        height: 100%;
        flex: 1 1 auto;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: space-between;
        background: var(--page-bg-img);
        background-size: cover;
        overflow: hidden;
        padding-bottom: 40px;

        .msg-box-flex-wrapper {
            flex: 1 1 auto;
            width: 100%;
            overflow: hidden;
        }

        .operate-wrapper {
            width: 100%;
            display: flex;
            align-items: center;
            padding-left: 60px;
            max-width: 1000px;

            .operate-item {
                margin-right: 20px;

                ::v-deep {
                    .el-checkbox__input {
                        position: relative;
                        top: -1px;
                    }
                }
            }

            .params-setting {
                cursor: pointer;

                .el-icon-s-tools {
                    margin-right: 4px;
                    font-size: 16px;
                }
            }
        }

        .input-box-flex-wrapper {
            flex: 0 0 auto;
            width: 100%;
            max-width: 1000px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;

            .input-placeholder {
                flex: 0 0 58px;
            }

            .gpt-chatbox {
                &.typing {
                    pointer-events: none;
                    opacity: 0.6;
                }
            }
        }
    }
    .params-setting-wrapper {
        width: 450px;
        height: 100%;
        padding: 20px;
        .params-item {
            display: flex;
            flex-direction: column;
            padding-bottom: 10px;
            border-bottom: 1px solid rgba(0,0,0,0.09);
            margin-bottom: 14px;
            .params-item-title {
                margin-bottom: 10px;
            }
        }
    }
    .bottom-tips {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: rgba(0,0,0,0.45);
        font-size: 12px;
        letter-spacing: 1px;
        .server-tips {
            color: #1890FF;
            cursor: pointer;
        }
    }
}
</style>
<style lang="scss">
.server-tips-dialog {
    width: 100%;
    height: 80%;
    margin-top: 0!important;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    .el-dialog__body {
        height: 100%;
        overflow: auto;
        padding-top: 0;
        padding-bottom: 0;
    }
    //.tips-top {
    //    width: 100%;
    //    display: flex;
    //    flex-direction: column;
    //    align-items: center;
    //    .time-wrapper {
    //        width: 100%;
    //        display: flex;
    //        flex-direction: column;
    //        align-items: flex-end;
    //        line-height: 24px;
    //    }
    //}
    .tips-content {
        line-height: 24px;
    }
}
</style>
